import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quoteOne } from "../../store/generateQuote/actions";
export var GetQuoteOne = function (trigger, quoteId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _a.responseOneQuote, errorOneQuote = _a.errorOneQuote, loadingOneQuote = _a.loadingOneQuote;
    useEffect(function () {
        if (trigger) {
            dispatch(quoteOne({
                id: quoteId,
                fullBody: true,
            }));
        }
    }, [trigger]);
    return {
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
    };
};
